import { SalaryPeriod } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    periods: [],
    period: {},
    loading: false,
    typeGroup: '',
    totalFee: null,
    loadingFee: false
  },
  actions: {
    async fetchPeriods({ commit, state }) {
      state.loading = true
      let periods = await SalaryPeriod.fetch({ _limit: -1 })
      commit('changeState', { periods: periods })
      state.loading = false
    },
    async fetchPeriod({ state, commit }, id) {
      state.loading = true
      let period = await SalaryPeriod.fetchOne(id)
      commit('changeState', { period })
      state.loading = false
    },
    async updatePeriod({ state, commit }, payload) {
      state.loading = true
      let period = await SalaryPeriod.update(payload.id, payload.data)
      commit('changeState', { period })
      state.loading = false
    },
    async reSummary({ state, commit }, { status, type, typeId, id, generatedBy, data }) {
      state.loading = true
      const updateParams = { status, type, typeId, generatedBy }
      if (type === 'specific') {
        delete updateParams.typeId
        updateParams['data'] = data
      }
      let period = await SalaryPeriod.update(id, updateParams)
      commit('changeState', {
        period,
        typeGroup: type
      })
      state.loading = false
    },
    async searchPeriod({ state, commit }, params) {
      state.loading = true
      let searchPeriods = await SalaryPeriod.search(params)
      commit('changeState', { periods: searchPeriods })
      state.loading = false
    },
    async getTotalFee({ state, commit, rootState }, params) {
      state.loadingFee = true
      let totalFee
      if (!params.student) {
        totalFee = await SalaryPeriod.getTotalFee(params)
      } else {
        let report = rootState.salaryReport.report ? rootState.salaryReport.report : 0
        totalFee = report.totalSumFee - report.totalMinusFee
      }
      commit('changeState', { totalFee })
      state.loadingFee = false
    },
    setLoadingFee({ state, commit }, data) {
      state.loadingFee = data
      commit('changeState', { loadingFee: data })
    },
    setTotalFeeNull({ commit }, params) {
      commit('changeState', {
        totalFee: 0
      })
    }
  },
  mutations: {
    resetData(state) {
      state.period = {}
      state.periods = []
    }
  },
  getters: {
    period(state) {
      return state.period
    },
    periods(state) {
      return state.periods
    },
    loading(state) {
      return state.loading
    },
    totalFee(state) {
      return state.totalFee
    },
    loadingFee(state) {
      return state.loadingFee
    }
  }
}
